import * as react_components from "../reactcomponent.js"
import * as utility from "../services.js"
import * as propertyTypes from "../property_types.js"
import * as datasources from "../common_metadata/datasource.js"
import { ErrorBoundary } from "../components/error_boundary.js"
import React from "react";
interface TemplateProps {
    uid: any;
    values: any;
    queryParameter: any;
    onTextChange(propertyName, value): any;
    context: utility.IContextProps;
    rootPropertyPath: any;
    extendedUid: string;
    metadataSettings: TemplateState
}

export class TemplateComponent extends React.Component<TemplateProps, any>{
    constructor(props) {
        super(props);
        this.state = {};
    }

    getColumnTemplate = () => {
        let template: any = this.props.metadataSettings.template;

        if (this.state.value === undefined && this.props.metadataSettings.dataSource && this.props.metadataSettings.dataSource.getDataSourceIdentifier() || !template) {
            return { __html: "<div></div>" };
        }

        try {
            template = kendo.template(template);
            var result: any = template({ row: this.state.value, context: this.props.context.variables, allRows: this.state.allRows });
        }
        catch (e) {
            result = '<div style = "color:red">Error in template:' + e.message + '</div>';
        }
        return { __html: result };
    }

    handleDataChanged = (allData) => {
        if (this.props.metadataSettings.dataSource) {
            let result = allData[this.props.metadataSettings.dataSource.getDataSourceIdentifier() + this.props.uid];
            if (!result) {
                result = allData[this.props.metadataSettings.dataSource.getDataSourceIdentifier()];
            }

            if (result && result.Data) {
                this.setState({ value: result && result.Data && result.Data[0] ? result.Data[0] : null, allRows: result ? result.Data : null });
            }
        }
    }

    registerComponent = (uid: string, services: string[], datasources: datasources.Datasource[]) => {
        this.props.context.registerComponent(uid, services, this.handleDataChanged, null, datasources);
    }

    UNSAFE_componentWillMount() {
        this.registerComponent(this.props.uid, null, [this.props.metadataSettings.dataSource]);
    }

    UNSAFE_componentWillReceiveProps(nextProps: TemplateProps) {
        if (this.props.metadataSettings.dataSource && this.props.metadataSettings.dataSource.getDataSourceIdentifier !== nextProps.metadataSettings.dataSource.getDataSourceIdentifier) {
            this.registerComponent(this.props.metadataSettings.uid, null, [this.props.metadataSettings.dataSource]);
            this.props.context.loadMissingData(this.props.queryParameter);
        }
    }

    componentWillUnmount() {
        this.props.context.unregisterComponent(this.props.metadataSettings.uid);
    }

    render() {
        return <react_components.ReactColumn width={this.props.metadataSettings.width}>
            <ErrorBoundary>
                <div style={{ overflow: "hidden" }} dangerouslySetInnerHTML={this.getColumnTemplate()} ></div>
            </ErrorBoundary>
        </react_components.ReactColumn>
    }
};


export class TemplateState extends propertyTypes.BaseComponentProps {
    private templateMetadata = new propertyTypes.TemplateProperty("template", "Template");
    public template: string;

    public dataSource: datasources.Datasource;

    private templateMetadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.templateMetadataAll = baseMetaData.concat([this.templateMetadata, datasources.dataSourceMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.templateMetadataAll;
    }
}
